export default "https://dakcheck.solease.nl/static/media/checkedIcon.419c6f2b.svg";